import { JobQueueMessageEntityModel } from "src/store/models/entity/jobQueueMessage/entity";
import { JobQueueMessageHelperModel } from "src/store/models/entity/jobQueueMessage/helper";

export const encooJobQueueMessageModels = {
  entity: JobQueueMessageEntityModel,
  helper: JobQueueMessageHelperModel,
};
